<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_invoice_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/sale/invoice" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onShow"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row-flex-x">
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">&nbsp;</label>
                                <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>                       
                        <div>
                            <DatePicker v-model="query.FromDate" :label="$t('from_date')"/>
                        </div>
                        <div>
                            <DatePicker v-model="query.ToDate" :label="$t('to_date')"/>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">{{$t('customer')}}</label>
                                <CustomerDropdown :include-search="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">{{$t('Payment')}}</label>
                                <select class="form-control form-control-sm" v-model="query.PStatus" @change="toList">
                                    <option value="0">{{$t('all')}}</option>
                                    <option value="1">Not Paid</option>
                                    <option value="2">Partially Paid</option>
                                    <option value="3">Paid</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead class="table-primary">
                        <tr>
                            <th style="width: 30px;" class="text-center">#</th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('TaxNum')">{{ $t('invoice_no') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Date')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DueDate')">{{ $t('due_date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('GrandTotal')">{{ $t('grand_total') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th>អ.ត.ប</th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('TotalAmount')">{{ $t('total_amount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Balance')">{{ $t('balance') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 110px;">
                                <span class="sort-field" @click="onSort('PaidStatus')">ការទូទាត់</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th style="width: 60px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{$format(ret.DueDate, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                                <td class="text-right">{{$money(ret.TaxVat)}}</td>
                                <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                                <td class="cell-badge" v-html="invStatus(ret)"></td>
                                <td class="text-center">
                                    <div class="cell-action">
                                        <router-link :to="{name: 'sale_invoice_view', params: {id: ret.Id}}" class="btn btn-outline-info btn-sm btn-xs"><i class="fa fa-eye" aria-hidden="true"></i></router-link>
                                        <a href="javascript:void(0)" class="btn btn-outline-info btn-sm btn-xs" @click="print(ret)"><i class="fa fa-print"></i></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="table-active">
                                <th colspan="5"></th>
                                <th class="text-right">{{$money(summary.grand)}}</th>
                                <th class="text-right">{{$money(summary.discount)}}</th>
                                <th class="text-right">{{$money(summary.amount)}}</th>
                                <th class="text-right">{{$money(summary.balance)}}</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
        <b-modal no-close-on-backdrop centered size="xl"
            modal-class="x-modal"
            title="IMPORT INVOICE"
            ref="innerform"
            footer-class="justify-content-between">
            <div class="vl-parent" ref="ldCond">
                <div class="row mb-2">
                    <div class="col-sm-4">
                        <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                        <button type="button" class="btn btn-success btn-sm" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-sm table-sm no-bor">
                            <thead>
                                <tr>
                                    <th>ល.រ</th>
                                    <th>ទំនិញឬសេវាកម្ម</th>
                                    <th>បរិយាយ</th>
                                    <th>ចំនួន</th>
                                    <th class="text-right">តម្លៃលក់</th>
                                    <th class="text-right">អ.ត.ប</th>
                                    <th class="text-right">ទឹកប្រាក់សរុប</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(inv,index) in imports">
                                    <tr class="table-active">
                                        <td colspan="7"> INV : {{ inv.Num }} {{ inv.CustomerName }} ({{ $format(inv.Date, 'DD/MM/YYYY') }}-{{ $format(inv.DueDate, 'DD/MM/YYYY') }})</td>
                                    </tr>
                                    <tr v-for="(ret, i) in inv.Lines">
                                        <td>{{  i + 1 }}</td>
                                        <td>{{  ret.ItemName }}</td>
                                        <td>{{  ret.Description }}</td>
                                        <td>{{  ret.Quantity }}</td>
                                        <td class="text-right">{{  $money(ret.Price) }}</td>
                                        <td class="text-right">{{  $money(ret.TaxAmount) }}</td>
                                        <td class="text-right">{{  $money(ret.SubTotal) }}</td>
                                    </tr>
                                    <tr class="table-info">
                                        <th class="text-right" colspan="5">ទឹកប្រាក់សរុប</th>
                                        <th class="text-right">{{ $money(inv.TaxVat) }}</th>
                                        <th class="text-right">{{ $money(inv.GrandTotal) }}</th>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <ul style="padding: 0; margin: 0; list-style-type: none;">
                            <li v-for="(ret,index) in errors" :key="index" style="color: red; padding: 5px;">{{ index + 1 }}. {{  ret }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div><button type="button" class="btn btn-outline-success btn-sm" :disabled="(imports.length==0 || errors.length > 0)" @click="onCopy"><i class="fa fa-copyright" aria-hidden="true"></i> IMPORT INVOICE</button></div>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { CustomerDropdown } from '../../Customer';
    import DatePicker from "../../Components/DatePicker.vue";    
    export default {
        components: { CustomerDropdown, DatePicker },
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Status: '',
                    PStatus: 0,
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    SortType: '',
                    SortField: '',
                    CompanyId: this.$store.state.company.Id
                },
                list: [],
                incomes: [],
                summary: {
                    grand: 0,
                    discount: 0,
                    tax: 0,
                    amount: 0,
                    balance: 0
                },
                imports: [],
                errors: [],
                header: { 'Content-Type': 'multipart/form-data' }
            }
        },
        created(){
          this.toList();
        },
        methods: {
            async toList(){                    
                var loading = this.$loading.show();
                await this.$api().post('invoice/list', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.Invoices;
                        this.query.Total = res.data.Total;
                        this.calculate();
                    }
                }).finally(() => { loading.hide(); });                
            },
            calculate(){
                let grand = 0;
                let discount = 0;
                let untax = 0;
                let tax = 0;
                let amount = 0;
                let balance = 0;
                this.list.forEach((item) => {
                    tax += item.TaxVat;
                    grand += item.GrandTotal;
                    discount += item.Discount;
                    untax += item.UntaxAmount;
                    balance += item.Balance;
                    amount += item.TotalAmount;
                });
                this.summary = {
                    grand: grand,
                    untax: untax,
                    tax: tax,
                    discount: discount,
                    amount: amount,
                    balance: balance
                };
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'sale/invoice/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sale-invoice.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            customerChange(e){
                if(e == null) this.query.CustomerId = '';
                else this.query.CustomerId = e.data.Id;
                this.toList();
            },
            print(item){
                if(item.InvoiceType == 'TAX')
                    window.open('/print/taxinvoice/' + item.Id, '_blank');
                else window.open('/print/nontaxinvoice/' + item.Id, '_blank');
            },
            invStatus(line){
                let cls = 'badge-danger';
                if(line.PaidStatus == 'Paid') {
                    cls = 'badge-success';
                }
                else if(line.PaidStatus == 'Partially Paid') {
                    cls = 'badge-warning';
                }
                return '<span class="badge '+cls+'">' + line.PaidStatus + '</span>';
            },
            onShow(){
                this.$refs.innerform.show();
            },
            onUpload(){
                var formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                formData.append('CompanyId', this.$store.state.company.Id);
                let loading = this.$loading.show();
                this.$api().post('invoice/upload', formData, this.header).then(res => {
                    if(this.$isValid(res)){
                        this.imports = res.data.Json.Invoices;
                        this.errors = res.data.Json.Validations;
                        this.$refs.file.value = null;
                    }
                }).finally(() => { loading.hide(); });
            },
            onCopy(){
                let loading = this.$loading.show({
                    container: this.$refs.ldCond
                });
                this.$api().post('invoice/import', this.imports).then(res => {
                    if(this.$isValid(res)){
                        this.imports = [];
                        this.$refs.innerform.hide();
                        this.toList();
                    }
                }).finally(() => { loading.hide(); });
            },            
        }
    }
</script>
